import { render, staticRenderFns } from "./azurelogin.vue?vue&type=template&id=570a184f&scoped=true&"
import script from "./azurelogin.vue?vue&type=script&lang=js&"
export * from "./azurelogin.vue?vue&type=script&lang=js&"
import style0 from "./azurelogin.vue?vue&type=style&index=0&id=570a184f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570a184f",
  null
  
)

export default component.exports